// import { Component } from '@angular/core';

// @Component({
//     selector: 'app-block-temp',
//     template: `
//     <div class="contenedorBlock">

//         <div class="img-loader text-center" style="background-color:#002554; display: flex; flex-direction: column; justify-content: center; align-items: center; width: 25%; height: 100px">
//             <img src="assets/img/ROTO-logo.svg" height="60px" alt="LOGIN">
//             <p class="txt" style="color:white !important">Cargando...</p>
//             <div class="spinner">
//                 <div class="double-bounce1"></div>
//                 <div class="double-bounce2"></div>
//             </div>
//         </div>
//     </div>
//   `,
//     styleUrls: ['./block-ui-template.component.scss']
// })
// export class BlockTemplateComponent { }


import { Component } from '@angular/core';

@Component({
    selector: 'app-block-temp',
    template: `
    <div class="contenedorBlock">
        
        <div class="img-loader">
            <!-- <img src="assets/img/IES-logo.svg" height="60px" alt="LOGIN"> -->
            <img src="assets/img/Logo_de_Rotoplas.svg" height="60px" alt="LOGIN">
            <p class="txt">Cargando...</p>
            <div class="spinner">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div>
        </div>
    </div>
  `,
    styleUrls: ['./block-ui-template.component.scss']
})
export class BlockTemplateComponent { }

